<template>
    <van-swipe :autoplay="3000" :height="170" :indicator-color="'#1A3232'">
        <van-swipe-item v-for="(image, index) in images" :key="index">
            <img :src="image" class="swiperImg"/>
        </van-swipe-item>
    </van-swipe>
</template>
<script>
export default {
    props: {
        images: {
            type: Array,
            default: () => []
        }
    }
}
</script>
<style lang="scss" scoped>
    .van-swipe{
        display: block;
        margin: 0;
        overflow: hidden;
    }
    ::v-deep .van-swipe__indicator{
        background-color:#DAEBE3;
        opacity:1
    }
    ::v-deep .van-swipe__indicators{
        position: absolute;
        bottom: 0.5rem;
        left: 50%;
        transform: translateX(-50%);
    }
    .my-swipe .van-swipe-item {
        color: #fff;
        font-size: 20px;
        line-height: 150px;
        text-align: center;
        background-color: #39a9ed;
    }
    .swiperImg{
        width: 100%;
        height: 9rem;
        object-fit: cover;
    }
</style>
